
/*
class Basic {
    __NAME__ = null;
    SET = null;
    constructor (name) {
        this.__NAME__ = name;
        this.SET = `set${name}`;
    }
    toString() {
        return this.__NAME__;
    }
}
 */

class Store {
    __NAME__ = null;
    constructor (name) {
        this.__NAME__ = name;
    }
    toString() {
        return this.__NAME__;
    }
    path(name) {
        return `${this.__NAME__}/${name}`
    }
}
export default {
    CART : new (class extends Store {
        TOTAL_QUANTITY = this.path('totalQuantity');
        ADD_ITEM = this.path('addItem');
        UPDATE_ITEM = this.path('updateItem');
        REMOVE_ITEM = this.path('removeItem');
        REMOVE_ALL = this.path('removeAll');
        INITIALIZE = this.path('initialize');
    })('cart'),
};
